// Mirrors the server-side Attendee.is_minimum_profile_complete rule so the
// frontend can react instantly to in-memory edits (e.g. unchecking credit
// types in MyCreditTypes) without waiting for a full attendee refresh from
// the API. Backend remains the source of truth for storage and reporting.

export function isMinimumProfileComplete(attendee) {
    if (null == attendee) {
        return false
    }
    if (!isTruthyString(attendee.display_name)) {
        return false
    }
    if (!isTruthyString(attendee.given_name)) {
        return false
    }
    if (!isTruthyString(attendee.family_name)) {
        return false
    }
    // A mailing address is required for everyone (profile verification),
    // including no-credit attendees, so it is checked before the no_ce_credit
    // short-circuit. usps_validated is soft/informational and not required
    // here — a US address USPS couldn't match still counts, and foreign
    // addresses are never USPS-validated.
    if (!hasRequiredAddress(attendee.registration_address)) {
        return false
    }
    if (attendee.no_ce_credit) {
        return true
    }
    const creditTypes = attendee.eligible_ce_credit_types || []
    if (0 === creditTypes.length) {
        return false
    }
    const validLicenseTypeIds = new Set()
    for (const license of attendee.professional_licenses || []) {
        if (isTruthyString(license.license_number)) {
            validLicenseTypeIds.add(license.id)
        }
    }
    for (const creditType of creditTypes) {
        const requiredLicenseTypeId = extractProfessionalLicenseTypeId(creditType)
        if (null == requiredLicenseTypeId) {
            continue
        }
        if (!validLicenseTypeIds.has(requiredLicenseTypeId)) {
            return false
        }
    }
    return true
}

function isTruthyString(value) {
    return 'string' === typeof value && '' !== value.trim()
}

function hasRequiredAddress(address) {
    if (null == address) {
        return false
    }
    if (!isTruthyString(address.country)) {
        return false
    }
    // Non-US addresses only record the country (informational); the US-format
    // fields are not collected, so they are not required.
    if ('US' !== address.country) {
        return true
    }
    return ['address1', 'city', 'state', 'postal_code']
        .every((field) => isTruthyString(address[field]))
}

function extractProfessionalLicenseTypeId(creditType) {
    const value = creditType.professional_license_type
    if (null == value) {
        return null
    }
    // Serializer may return the FK as a bare id or as a nested object with {id, ...}.
    if ('object' === typeof value) {
        return value.id
    }
    return value
}
